import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/error-boundary/GlobalErrorHandler.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/image/CustomImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalePrefixProvider","useLocalePrefix"] */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/locale-prefix/LocalePrefixContext.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/MetricsReporter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationScrollPaddingFix"] */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/navigation/NavigationScrollPaddingFix.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/ClientPageProviders.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-agreement/CosmosPageAgreement.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-auth/CosmosPageAuth.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-blog-detail/CosmosPageBlogDetail.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-error-test/ErrorTestPage.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-eula-key/CosmosPageEulaKey.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-legal-content/CosmosPageLegalContent.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-license/CosmosPageLicense.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-plugin-detail/CosmosPagePluginDetail.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CosmosPageResearch"] */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-research/CosmosPageResearch.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-search/CosmosSearch.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/templates/TemplateProviders.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/node_modules/.pnpm/next@15.5.12_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_babel-_5d47a2115d84463404f988052fbf195f/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/websites/legalhub-website/src/app/context/component-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalHubHomeClient"] */ "/runner/_work/cosmos-src/cosmos-src/websites/legalhub-website/src/app/templates/document-list/DocumentListPage.client.tsx");
